import { memo } from "react";
import BillingDataForm from "./components/BillingDataForm";
import SectionTitle from "../SectionTitle";
import { PurchaseStepE } from "../../models/enums";

import styles from "./styles.module.scss";

const BillingInformationSection = memo(() => {
  return (
    <div className={styles.purchasePaymentSection} id="billing-info-section">
      <div
        className={styles.paymentSectionStep2 + " " + styles.paymentSectionStep}
      >
        <SectionTitle
          titleTextKey="billing-information-title"
          step={PurchaseStepE.SECOND_INVOICE_DETAILS_STEP}
          className={styles.paymentSectionTitle}
        />
        <div className={styles.paymentSectionBody}>
          <BillingDataForm />
        </div>
      </div>
    </div>
  );
});

export default BillingInformationSection;
